<template>
  <Modal :mask-closable="false" width="750" v-model="modal" :footer-hide="true">
    <p slot="header" class="ph">
      <span>{{ $t("title.w16") }}</span>
      <span
        class="lastSpan"
        @click="getPDF"
        v-if="
          (type == 3 || type == 7) &&
            [1, 2, 6, 7, 100, 200].indexOf(data.State) > -1
        "
      >{{ $t("title.w65") }}</span>
    </p>
    <div class="content" id="procontent">
      <ProtocolTextHk
        :type="type"
        :agreeData="agreeData"
        :personMsg="personMsg"
        v-if="lang === 'hk'"
        id="procontent1"
      />
      <ProtocolText
        :type="type"
        :agreeData="agreeData"
        :personMsg="personMsg"
        v-else
        id="procontent1"
      />
    </div>
  </Modal>
</template>
<script>
import ProtocolText from "./protocolText";
import ProtocolTextHk from "./protocolText_hk";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
  components: { ProtocolText, ProtocolTextHk },
  props: ["data"],
  data() {
    return {
      modal: false,
      type: "",
      agreeData: "",
      personMsg: "",
    };
  },
  mounted() {
    // console.log(this.type)
    // console.log(this.data.State)
    // console.log([1,2,7,100,200].indexOf(this.data.State)>-1)
  },
  methods: {
    getPDF() {
      let title = this.$t("other.w60");
      var content = document.getElementById("procontent1");
      let clone = document.createElement("div");
      clone = content.cloneNode(true);
      clone.id = "pdf_temp_content";
      document.body.append(clone);
      var element = document.getElementById("pdf_temp_content");
      element.style.background = "#FFFFFF";
      element.style.width = "750px";
      element.style.fontSize = "16px";
      element.style.lineHeight = "30px";
      html2Canvas(element, {
        logging: false,
      }).then(function (canvas) {
        var pdf = new JsPDF("p", "mm", "a4"); //A4纸，纵向
        var ctx = canvas.getContext("2d"),
          a4w = 190,
          a4h = 275, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor((a4h * canvas.width) / a4w), //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;

        while (renderedHeight < canvas.height) {
          var page = document.createElement("canvas");
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight); //可能内容不足一页

          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page
            .getContext("2d")
            .putImageData(
              ctx.getImageData(
                0,
                renderedHeight,
                canvas.width,
                Math.min(imgHeight, canvas.height - renderedHeight)
              ),
              0,
              0
            );
          pdf.addImage(
            page.toDataURL("image/jpeg", 1.0),
            "JPEG",
            10,
            10,
            a4w,
            Math.min(a4h, (a4w * page.height) / page.width)
          ); //添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) pdf.addPage(); //如果后面还有内容，添加一个空页
          // delete page;
        }
        pdf.save(title + ".pdf");
        document.getElementById("pdf_temp_content").remove();
      });
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  height: 400px;
  overflow: auto;
  padding-right: 15px;
}
/deep/ .ivu-modal-body {
  padding-right: 10px;
}
.ph {
  display: flex;
  justify-content: space-between;
  .lastSpan {
    margin-right: 60px;
    cursor: pointer;
    color: #5e8ffc;
  }
}
#pdf_temp_content {
  table {
    td {
      padding: 0 10px !important;
    }
  }
}
</style>
